import React, { useContext } from 'react';
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { setAvailableOptions } from '../actions/actionsAppTest';
import { fetchSimulationOptionsIfNeeded } from '../actions/actionsApiSimulation';
import TestOptions from '../components/testCriteria/TestOptions';

export default function ContTestOptionsAvailable() {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onChangeOptions(options) {
    fetchSimulationOptionsIfNeeded(globalstate, dispatch, {}, options, null, null, false);
    dispatch(setAvailableOptions(options));
  }


  return (
    <TestOptions
      data={globalstate.testCriteria.availableOptions}
      settings={globalstate.settings}
      onChangeOptions={onChangeOptions}
    />);
}
